export interface HrPosition {
  id: string
  name: string
  department_id?: number
}
